import { ReactNode } from "react";

interface PageTitleProps {
  children?: ReactNode;
  className?: string;
}

export function PageTitle({ children, className, ...props }: PageTitleProps) {
  return (
    <h1
      className={`text-3xl font-medium font-tiempos mt-6 ${className}`}
      {...props}
    >
      {children}
    </h1>
  );
}
